import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { Component } from 'react';
import { e as emptyIcon } from '../utils/emptyIcon-D6JwmRyF.js';
import { r as renderIconSVG } from '../utils/renderIconSVG-y_LSJnGl.js';

const rawIconErrorData = {
  __html: renderIconSVG({
    prefix: 'far',
    iconName: 'error-icon',
    icon: emptyIcon
  }, undefined, '')
};
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true
    };
  }
  render() {
    const {
      hasError
    } = this.state;
    if (hasError) {
      // eslint-disable-next-line react/no-danger
      return /*#__PURE__*/React__default.createElement("span", {
        dangerouslySetInnerHTML: rawIconErrorData,
        "data-testid": "storm-ui-icon-error-icon"
      });
    }
    const {
      children
    } = this.props;
    return children;
  }
}
_defineProperty(ErrorBoundary, "defaultProps", void 0);

export { ErrorBoundary as E };
//# sourceMappingURL=ErrorBoundary-CZ3V3ZIp.js.map
